<template>
      <nav class=" lg:flex justify-between  ">
          <div class="ms-2">
            <ul class="flex  gap-4 list-none nav-bar-hover text-sm  public-text items-center h-10">
              <li class="nav-list "><router-link to="/"> خانه </router-link></li>
              <li class=" relative cursor-pointer h-10 flex items-center group "  @mouseover="showMegaMenu" @mouseleave="closeMegaMenu">
                <div class="sub-menu flex items-center group-hover:text-blue-500 " @focus="megaMenu=true">
                  لباس کار
                  <!-- <font-awesome-icon icon="chevron-down" class="w-3 h-3 ms-1 svg transition-transform duration-[0.2s]" :class="megaMenu?'rotate-180':''"/> -->
                </div>
                <div class="absolute top-4 left-0  w-full  ">
                  &nbsp;
                </div>
                <!-- mega menu  -->
                <Transition name="mega-menu-fade">
                <div v-show="megaMenu" class="absolute  top-[2.7rem] -right-4 bg-white w-96  py-2 px-4  z-20 flex gap-2 overflow-hidden shadow-md shadow-blue-200 rounded-lg">
                  <div class="w-1/3">
                    <ul>
                      <li class=" hover:text-blue-500 transition-all duration-75 mb-2 px-2 ">
                        <router-link   :to="{ name: 'category', params: { name: 'دوتکه-کار' } }"
                        aria-label="دوتکه کار">
                          دوتکه کار
                        </router-link>

                      </li>
                      <li class=" hover:text-blue-500 transition-all duration-75 mb-2 px-2">
                        <router-link :to="{ name: 'category', params: { name: 'یکسره-کار' } }"
                            aria-label="یکسره کار">
                          یکسره کار
                        </router-link>
                      </li>
                      <li class=" hover:text-blue-500 transition-all duration-75 mb-2 px-2">
                        <router-link  :to="{ name: 'category', params: { name: 'دوبنده-کار' } }"
                        aria-label="دوبنده کار">
                          دوبنده کار
                        </router-link>
                      </li>
                      <li class=" hover:text-blue-500 transition-all duration-75  px-2">
                        <router-link :to="{ name: 'category', params: { name: 'تیشرت-کار' } }"
                        aria-label="تیشرت کار">
                          تیشرت کار
                        </router-link>
                      </li>
                    </ul>
                  </div>
                  <div class="w-1/3">
                    <ul>
                      <li class=" hover:text-blue-500 transition-all duration-75 mb-2 px-2">
                        <router-link :to="{ name: 'category', params: { name: 'جلیقه-کار' } }"
                        aria-label="جلیقه کار ">
                          جلیقه کار
                        </router-link>
                      </li>
                      <li class=" hover:text-blue-500 transition-all duration-75 mb-2 px-2">
                        <router-link :to="{ name: 'category', params: { name: 'شلوار-کار' } }"
                        aria-label="شلوار کار">
                          شلوار کار
                        </router-link>
                      </li>
                      <li class=" hover:text-blue-500 transition-all duration-75 mb-2 px-2">
                        <router-link   :to="{ name: 'category', params: { name: 'آشپزی' } }"  aria-label="آشپزی">
                          آشپزی
                        </router-link>
                      </li>
                      <li class=" hover:text-blue-500 transition-all duration-75  px-2">
                        <router-link   :to="{ name: 'category', params: { name: 'بادگیر' } }"  aria-label="بادگیر">
                          بادگیر
                        </router-link>
                      </li>
                    </ul>
           
                  </div>
                  <div class="w-1/3">
                    <ul>
                      <li class=" hover:text-blue-500 transition-all duration-75 mb-2 px-2">
                        <router-link  :to="{ name: 'category', params: { name: 'کت-و-کاپشن' } }" aria-label="کت و کاپشن">
                          کت و کاپشن
                        </router-link>
                      </li>
                      <li class=" hover:text-blue-500 transition-all duration-75 mb-2 px-2">
                        <router-link  :to="{ name: 'category', params: { name: 'زنانه' } }" aria-label="زنانه">
                          زنانه 
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </Transition>
              </li>
              <li class="nav-list "><router-link :to="{ name: 'category', params: { name: 'کفش-کار' } }" aria-label="کفش کار">کفش کار </router-link></li>

              <li class="nav-list"><router-link  :to="{ name: 'category', params: { name: 'تجهیزات-ایمنی' } }" aria-label="تجهیزات ایمنی">تجهیزات ایمنی</router-link></li>

              <li class="nav-list"><a href="https://parsinekala.com/blog/" target="_blank">مقالات</a></li>
              <li class="nav-list"><router-link to="/work-with-us">همکاری با ما</router-link></li>
              <li class="nav-list"><router-link to="/aboutUs">درباره ما</router-link></li>
              <li class="nav-list"><router-link to="/contactUs">تماس باما</router-link></li>
            </ul>

          </div>
        </nav>
</template>
<script setup>
import {ref } from 'vue'

const megaMenu=ref(false)
const showMegaMenu=()=>{
  megaMenu.value=true
}
const closeMegaMenu=()=>{
  megaMenu.value=false
}

</script>
<style >
.mega-menu-fade-enter-active ,.mega-menu-fade-leave-active{
  transition:  all 0.2s ease-in-out;
}
.mega-menu-fade-enter ,.mega-menu-fade-leave-to{
 opacity: 0;
  transform: translateY(-12px);
}
</style>